// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JoinPanel_main__1tKIx {
  height: 48px;
  width: 100%;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  border-top: 1px solid #E5E6EE;
  background: #FAFBFC;
  cursor: pointer;
  color: #4778EE;
  font-size: 14px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/JoinPanel/JoinPanel.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,SAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;AAFF","sourcesContent":[".main {\n  height: 48px;\n  width: 100%;\n  outline: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border: 0;\n  border-top: 1px solid #E5E6EE;\n  background: #FAFBFC;\n  cursor: pointer;\n\n  color: #4778EE;\n  font-size: 14px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `JoinPanel_main__1tKIx`
};
export default ___CSS_LOADER_EXPORT___;
